import React from 'react'

export default function Example() {
  return (
    <div className="bg-white py-40 px-5">
      <div className="mx-auto sm:max-w-max lg:max-w-7xl">
        <div className="relative z-10 mb-8 md:mb-2 md:px-6">
          <div className="max-w-prose text-base lg:max-w-none">
            <p className="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
              Support              </p>
          </div>
        </div>
        <div>         
          <div className="relative md:bg-white md:p-6">
            <div className="lg:grid lg:grid-cols-2 lg:gap-6">
              <div className="prose prose-lg prose-indigo text-gray-500 lg:max-w-none">
                <p className="py-4">
                  All of us here at VaultBet want betting to be fun. A way to socialise, a chance to prove your powers of foresight, with the bonus of a little ICP if and when you win.
                </p>
                <p className="py-4">
                  What we don’t want, is for betting or gaming to have a damaging effect on people’s lives. We are committed to responsible gambling and take compulsive gambling problems exceedingly seriously.
                </p>
                <p className="pt-4">
                  If you suspect you may have a gambling problem, you can contact :
                </p>
                <a href='http://jugadoresanonimos.net/'>
                  http://jugadoresanonimos.net/
                </a>
                <p>
                Have a look, and keep yourself aware – if it’s not fun, take action to control your play.
                </p>

              </div>
              <div className="prose prose-lg prose-indigo mt-6 text-gray-500 lg:mt-0">
              <p>
                  Remember :
                </p>
                <ul role="list">
                  <li className="px-3">Gambling is a form of entertainment. It is not a way to get rich quickly and pay off your debts.
                  </li>
                  <li className="px-3">Gambling is a game of chance. There are no formulas that guarantee winnings.
                  </li>
                  <li className="px-3">Make sure that the decision to gamble is your choice.
                  </li>
                  <li className="px-3">Never try to chase your losses.</li>
                  <li className="px-3">Check the amounts you spend on a regular basis.
                  </li>
                  <li className="px-3">Make sure you know the rules of the games you play.</li>
                </ul>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  )
}
